<template>
  <div>
    <div class="black-overlay"></div>
    <div class="modal modal--welcomeback modal--ranking" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ getTranslations.home_modals_ranking_type }}</h1>
          <p>{{ getTranslations.home_modals_ranking_date }}</p>
          <img class="usericon" src="static/images/prize.png" alt="">
        </div>
        <div class="modal__body">
          <p class="ranking_prize">[{{ getTranslations.home_modals_ranking_prize }}]</p>
          <p>{{ getTranslations.home_modals_ranking_rank }}: {{ getShowmodalForRanking.userLevel }}</p>
          <p>{{ getTranslations.home_modals_ranking_points }}: {{ getShowmodalForRanking.gamesEarned }}</p>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ranking',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getShowmodalForRanking',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Ranking.vue